import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { editGuestDetail, getSalesOrderDetail, returnUpdate } from "../actions";
import Header from "../Components/header";
import NavigationButtons from "../Components/navigationButton";
import SectionForm from "../Components/sectionForm";
import { getPicklist, isDifferentValue } from "../util/helpers";
import Swal from "sweetalert2";
import InputDate from "../../../components/global/InputDate";
import dayjs from "dayjs";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2Step3 extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isGetDataLoading: false,
      isOpen: false,
      form: {
        Check_In__c: "", // Added for check-in date
        Dietary_Requirements__c: "", // Added for dietary requirements
        Bed_configuration_preference__c: "", // Added for bedding configuration
        Any_other_special_request_for_the_resort__c: "", // Added for special requests
      },
    };
  }

  componentDidMount() {
    const { guestDetail } = this.props.vf2;

    if (guestDetail) {
      console.log(guestDetail)
      this.setState({
        form: {
          Check_In__c: guestDetail.Check_In__c ? guestDetail.Check_In__c : 
            guestDetail.Sales_Order_No__r?.Trip_Start_Date__c ? guestDetail.Sales_Order_No__r?.Trip_Start_Date__c : '', // Added for check-in date
          Dietary_Requirements__c: guestDetail.Dietary_Requirements__c ?? '', // Added for dietary requirements
          Bed_configuration_preference__c: guestDetail.Bed_configuration_preference__c ?? '', // Added for bedding configuration
          Any_other_special_request_for_the_resort__c: guestDetail.Any_other_special_request_for_the_resort__c ?? '',
        },
      });
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
    }));
  };

  handleSave = async () => {
    const { form } = this.state;
    this.setState({ isLoading: true });
    try {
      if(!form.Check_In__c){
        throw new Error(`${this.props.t("Check in Date is required")}!`)
      }
      const {guestDetail} = this.props.vf2
      if(isDifferentValue(form, guestDetail)){
        // if(!guestDetail.Arrival_Date_Time__c){
        //   form.Arrival_Date_Time__c = mergeDateTime(form.Check_In__c, '00:00')
        // }
        await this.props.editGuestDetail(form, guestDetail.Id, this.props.returnUpdate, 'detail');
      }
    } catch (error) {
      let errorMessage = this.props.t("An unknown error occurred");
      if (error.response) {
        errorMessage = error.response.message || "Login failed"; // Server error
      } else if (error.message) {
        errorMessage = error.message; // Client-side or network error
      }
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: `${this.props.t("Something went wrong!")} ${errorMessage}`,
      });
      return false
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { describe, guestDetail, agentDetail } = this.props.vf2;
    const { form } = this.state;

    return (
      <>
        <div style={{ margin: "30px", position: 'relative' }}>
          <Header 
            title={this.props.t("Wakatobi Resort and Yacht Stay")}
            subtitle={this.props.t("Tell us about your stay preferences at Wakatobi")} 
            selectedGuest={guestDetail}
            agent={agentDetail}
          />

          <SectionForm title={this.props.t("Arrival")} subtitle={this.props.t("Let us know about your arrival details")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={6}>
                <Typography variant="body1">
                  {this.props.t("Check-In Date")}
                </Typography>
                <InputDate
                  sx={{ marginTop: 0 }}
                  name="Check_In__c"
                  value={form.Check_In__c ? dayjs(form.Check_In__c) : null}
                  format={'DD-MMM-YYYY'}
                  onChange={(e) => 
                    this.handleChange({target: {name: 'Check_In__c', value: dayjs(e.$d).format("YYYY-MM-DD")  
                  }})}
                />
              </Grid>
            </Grid>
          </SectionForm>

          <SectionForm title="Accommodation" subtitle="Do you have any requests?">
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("Dietary Requirements")}
                </Typography>
                <TextField
                  name="Dietary_Requirements__c" // Add name for input identification
                  value={form.Dietary_Requirements__c} // Use controlled input
                  onChange={this.handleChange} // Handle change
                  variant="outlined"
                  placeholder="Description"
                  fullWidth
                />
                <Typography variant="body1" sx={{ color: '#667085', fontWeight: 300 }}>
                  ({this.props.t("For example do you prefer meat, fish or vegetarian food?")})
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("Bedding Configuration")}
                </Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="bedding-config-label"
                    name="Bed_configuration_preference__c" // Add name for input identification
                    value={form.Bed_configuration_preference__c || ''} // Use controlled input
                    onChange={this.handleChange} // Handle change
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t("Select Configuration")}</MenuItem>
                    {getPicklist('Bed_configuration_preference__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{this.props.t(value)}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("Any other special requests for the Resort?")}
                </Typography>
                <TextField
                  name="Any_other_special_request_for_the_resort__c" // Add name for input identification
                  value={form.Any_other_special_request_for_the_resort__c} // Use controlled input
                  onChange={this.handleChange} // Handle change
                  variant="outlined"
                  placeholder={`${this.props.t("Enter a description")}..`}
                  fullWidth
                  multiline // Set to true for textarea
                  rows={5} // Number of visible lines
                />
              </Grid>
            </Grid>
          </SectionForm>
          
          <NavigationButtons 
            nextUrl={`${URL_PREFIX}/vf2/wizard/flight`} 
            backUrl={`${URL_PREFIX}/vf2/wizard/diving`} 
            onSave={this.handleSave} 
            isLoading={this.state.isLoading} 
            showSave
            showBack
            showNext // Change to false to hide the Next button
          />
         
        </div>
      </>
    );
  }
}

VF2Step3.propTypes = {
  vf2: PropTypes.object.isRequired,
  // nextStep: PropTypes.func.isRequired,
  // previousStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editGuestDetail,
      getSalesOrderDetail,
      returnUpdate
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2Step3));